var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasError
        ? _c(
            "no-results",
            {
              attrs: {
                icon: "fa-exclamation-circle",
                "icon-class": "text-danger",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "notification-messages.somethingWentWrongTryAgainLater"
                    )
                  ) +
                  "\n  "
              ),
            ]
          )
        : [
            _vm.loading ? _c("default-body-loader") : _vm._e(),
            _vm._v(" "),
            _c("iframe", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading",
                },
              ],
              ref: "iframeElement",
              staticClass: "preview-iframe",
              attrs: { scrolling: "no", frameborder: "0", width: "100%" },
              on: { load: _vm.onLoad },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }